import {observer} from "mobx-react";
import styled from "styled-components";
import CustomSwiper from "@/components/common/CustomSwiper";
import {SIZES} from "@/components/constants";
import {useStore} from "@/store";
import {useEffect} from "react";

const MainVisualBanner = observer(({className}) => {
    const {bannerStore} = useStore();
    useEffect(() => {
        bannerStore.setFetchBannerList().then();
    }, []);

    return(

        <MainVisualWrap className={className}>
            {
                bannerStore.visibleBanner && bannerStore.visibleBanner.length > 0 &&
                    <CustomSwiper
                        slides={bannerStore.visibleBanner.map(item => ({imageItem: typeof item.data.image === "string" ? JSON.parse(item.data.image).path : item.data.image.path, link: item.data.url,}))}
                        effect="fade"
                        className="main-swipe"
                        progressBar={true}
                        pause={true}
                        delay={2000}
                        autoplayDelay={2000}
                        speed={800}
                        autoplay={true}
                        direction={"horizontal"}
                    />
            }
            {/*<div className={"text-box"}>*/}
            {/*    <FadeWrap>*/}
            {/*        <p>Your Partner</p>*/}
            {/*    </FadeWrap>*/}
            {/*    <FadeWrap>*/}
            {/*        <p>in Scientific Discovery</p>*/}
            {/*    </FadeWrap>*/}
            {/*</div>*/}
        </MainVisualWrap>
    )
});
const MainVisualWrap = styled.div`
    position: relative;
    min-height: 100vh;
    height: calc(var(--vh) * 100);
    .point{
        cursor: pointer;
    }
    .main-swipe{
        width: 100%;
        height: 100%;
        position: relative;
        .swiper{
            width: 100%;
            height: 100%;
            .image-wrap{
                width: 100%;
                height: 100%;
            }
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .controller{
            display: flex;
            gap: 10px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 105px;
            z-index: 10;
            width: 100%;
            align-items: center;
            justify-content: center;
        }
        .progress-bar{
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            gap: 10px;
            .bar {
                background: rgba(255, 255, 255, 0.2);
                width: 80px;
                height: 2px;
                .fill {
                    height: 100%;
                    background: #fff;
                }
            }
        }
    }
    .text-box{
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 40;
        color: #fff;
        text-align: center;
        white-space: pre-line;
        pointer-events: none;
        p{
            font-weight: 700;
            font-size: 82px;
            line-height: 140%;
            text-align: center;
            letter-spacing: -0.02em;
            color: #FFFFFF;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .main-swipe{
            .controller{
                top: calc(50% + 104px);
                transform: translate(-50%, -50%);
                bottom: auto;
                .pause-btn{
                    display: none;
                }
            }
        }
        .text-box{
            p{
                font-weight: 700;
                font-size: 32px;
                line-height: 140%;
                letter-spacing: -0.02em;
            }
        }
    }
`

const FadeWrap = styled.div`
    overflow: hidden;
    & > * {
        display: inline-block;
        transform: translateY(100%);
        opacity: 0;
        animation: fadeUp .5s ease-out forwards;
    }
    
    &:nth-child(1) > * {
        animation-delay: 0.2s;
    }
    &:nth-child(2) > * {
        animation-delay: 0.4s;
    }
    &:nth-child(3) > * {
    animation-delay: 0.6s;
    }
    @keyframes fadeUp {
        0% {
            opacity: 0;
            transform: translateY(40px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;
export default MainVisualBanner;